import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@pitchero/react-ui';

const ProfileFixturesFilter = ({ eventTypes, selected, onChange }) => {
  const selectOptions = eventTypes.map((eventType) => ({
    value: eventType.id,
    name: `${eventType.label} (${eventType.count})`,
  }));

  return <Select options={selectOptions} onChange={onChange} value={selected} />;
};

ProfileFixturesFilter.propTypes = {
  eventTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      count: PropTypes.number,
    }),
  ).isRequired,
  selected: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ProfileFixturesFilter;
